export default "__VITE_ASSET__PUEdtehK__"